import IyzicoCampaign from './IyzicoCampaign'

export default IyzicoCampaign
